import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc80 = {
    title: "Image 80: Example of a child diaper changing station.",
    para1: "The image shows the details of a child diaper changing station. The room has two chairs, a sink and a diaper changing area. The room also has two posters on the wall advertising various baby products and instructions for using the baby diaper changing station. The sink is a rectangular white ceramic basin mounted on a light-colored vanity unit. The diaper changing station is grey with a safety harness. A shelf is mounted below the cabinet. The two chairs are made of wood with slatted backs and straw seats.",
}

export const ImageDesc81 = {
    title: "Image 81: Example of a child protection seat.",
    para1: "The image is of a child protection seat mounted on a wall in a public restroom. The seat is made of plastic with a fixed plastic fitting to ensure the child is seated in place. There is a signage above the protection seat which is red and white. The sign is maroon with white text that translates to “How to use the Baby Seat” in English, Hindi and Kannada. The poster also gives instructions on how to use the seat. ",
}

export const ImageDesc82 = {
    title: "Image 82: Example of an adult diaper changing station.",
    para1: "The image shows an adult-sized changing table in a public restroom.  This type of changing table is intended for people with disabilities or those who require assistance with changing clothes or using the restroom. There is a sign on top of it which gives instructions on how to use the changing station.",
}

export const ImageDesc83 = {
    title: "Image 83: Example of an accessible toilet with adult diaper changing stations and a ceiling-mounted hoist.",
    para1: <>
        <p>The image shows an adult-sized changing table in a public restroom.  This type of changing table is intended for people with disabilities or those who require assistance with changing clothes or using the restroom. There is a device on top of the changing table that may help to lift the person using the table or help them sit up. There is a sign on top of it which gives instructions on how to use the changing station.</p>
        <p>There is an accessible WC next to the diaper changing station. The WC is extended and there is a fixed metal bar on one side to aid with movement. The metal bar on the other side of the WC is foldable, and is in a folded position in this image. </p>
    </>,
}

export const ImageDesc84 = {
    title: "Image 84: Example of a feeding room.",
    para1: "This image shows an example of a part of a feeding room. There is a plush armchair in the corner of the room. There is a floor lamp next to the armchair. The lamp has a white lampshade and a metal base. There is a small round table next to the armchair. The room has been furnished to make the users comfortable while using the space. ",
}

export const ImageDesc85 = {
    title: "Image 85: Example of an outdoor play area.",
    para1: <>
        <p>This image is an example of an outdoor playground with several pieces of equipment for children to play on. There is a red merry-go-round. To the right of the merry-go-round, there are two swings. There is a see-saw behind the merry-go-round. There is a yellow slide next to the see-saw. </p>
        <p>There are also benches for adults to sit on while they watch their children play. The ground covering in the playground appears to be a soft rubber material. There are also trees in the background that provide shade.
        </p>
    </>,
}

export const ImageDesc86 = {
    title: "Image 86: Example of an indoor play area.",
    para1: <>
        <p>This image is an example of an indoor play area with a swing, a jungle gym, and other play equipment. The swing is a white rope swing hanging from a metal frame secured to the ceiling. The seat of the swing is green in colour. The jungle gym has a slide and rollers that are blue, red and yellow in colour.  There is blue and red cylindrical play equipment. </p>
        <p>There are soft mats on the floor around the play equipment. There are several toys scattered around the floor.</p>
        <p>There is a window on the left wall of the playroom and a poster. The entire play area is designed to be colourful. </p>
    </>,
}

export const ImageDesc87 = {
    title: "Image 87: Example of a crèche/daycare facility.",
    para1: <>
        <p>This image is an example of a creche or a daycare facility. The room has a blue sofa set, a colorful rug, and toys in baskets. The rug is colorful and patterned. It appears to be made of a woven material.</p>
        <p>The room has several open and closed storage cupboards. The open cupboards also have toys in them. There are potted plants on some of the shelves. The overall impression of the living room is that it is playful, with furniture and equipment made to be in soothing colours.</p>
    </>,
}

export const FigureDesc68 = {
    title: "Figure 68: Typical floor plan for a feeding room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure shows a floor plan for a feeding room (2700 mm x 2000 mm). The entrance provided at the top-left corner of the layout.
        </p>
        <p>The features are described in a clockwise manner. </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance door leading to the feeding room is provided at the top-left corner of the layout.",
                    "A surface is provided on the right wall of the room to place feeding essentials. A provision for electrical outlets for breast pumps is also placed here.",
                    "A comfortable chair for feeding is present in the centre of the room. Other amenities for comfort are also provided in the room.",
                    "Side tables are provided for placing essentials within easy reach.",
                    "A  window is provided behind the chair.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc69 = {
    title: "Figure 69: Typical floor plan for an accessible outdoor children’s play area. ",
    para1: <>
        <p>
            <span><b>Orientation of the Floor Plan: </b></span>
            The figure shows a floor plan for an accessible outdoor children’s play area, with amenities for ensuring engagement and activities for children. An accessible access route to travel through the play area has been provided, starting from the bottom of the layout. The features are described from bottom to top.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "At the bottom-left corner of the floor plan, there is a child-friendly accessible drinking water facility.",
                    "There is an accessible route (width 900 mm) to travel through the play area, starting from the bottom and winding to the top-left corner of the layout.",
                    "The play area has accessible instruments and features for children such as wall marimba, accessible sandpit, wheelchair carousel, spring rider and emperor chimes (musical instrument). Insets are provided at the right of the layout, showcasing the details of the wheelchair carousel, spring rider, and wall marimba through representative images.",
                    "To the left side of the play area, 2 benches are provided for seating. There are potted plants and grass near the seating area.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc70 = {
    title: "Figure 70: Typical floor plan for an accessible indoor play area.",
    para1: <>
        <p>
            <span><b>Orientation of the Floor Plan: </b></span>
            The figure shows a floor plan for an accessible indoor play area for children. The features are described from left to right.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "An elevated area is provided for seating at the left of the layout. Toys and other amenities are provided at the top of these chairs, along the remainder of the wall on the left.",
                    "A sensory board is provided at the top of the layout.",
                    "A bench for seating is additionally provided at the bottom of the play area.",
                    "The flooring is soft, to ensure comfort. Potted plants are also provided.",
                    "The entire area is designed to have soft furnishings and minimal elevation to ensure children can easily move through the space.",

                ])}
            </div>
        </p>
    </>
}





